import axios from 'axios'
import { useMutation } from 'react-query'
import { FormType } from '../../templates/valutaImmobile'

const usePostForm = () => {
  return useMutation((item: FormType) => {
    const { privacy, ...finalData } = item
    return axios.post('https://api.immobili.f2.net/v1/form_richiesta?t=7e4aac8c-06e8-4d5f-bf7b-1ba227acadf9', finalData)
  })
}

export default usePostForm
